import { customElement, autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';

@customElement('mdc-file')
@autoinject
export class MdcFile {
  constructor(private element: Element) { }

  @bindable
  caption = 'File';

  @bindable.booleanAttr
  multiple: boolean = false;

  @bindable
  labelValue: string = '';

  @bindable.booleanAttr
  disabled: boolean;

  @bindable.booleanAttr
  readonly: boolean;

  @bindable
  accept: string;

  files: FileList;

  input: HTMLInputElement;

  clear() {
    this.input.value = '';
  }
}
